/*
 * @Description: 引导页
 * @Author: ZY
 * @Date: 2021-01-21 20:13:03
 * @LastEditors: ZY
 * @LastEditTime: 2021-01-21 21:24:27
 */
import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const AgencyRouter: Array<RouteRecordRaw> = [
  {
    path: '/page',
    component: Layout,
    redirect: '/page/page_setup_menus',
    children: [
      {
        path: 'page_setup_menus',
        component: () => import(/* webpackChunkName: "guide" */ '@/views/agency/Index.vue'),
        name: 'Page',
        meta: {
          title: 'page',
          icon: '#iconguide'
        }
      },
      {
        path: 'vue',
        component: () => import(/* webpackChunkName: "guide" */ '@/views/agency/Index.vue'),
        name: 'Page11',
        meta: {
          title: 'page22',
          icon: '#iconguide'
        }
      }
    ]
  }
]

export default AgencyRouter
